import React, { useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "antd";
import Linechart from "../../../components/dashboard/linechart";
import TaskCard from "../../../components/cards/taskCard";
import { useTranslation } from "react-i18next";
import UploadedDocs from "../../../components/dashboard/uploadedDocs";
import ClientTable from "./clientTable";
import OverviewTable from "./overviewTable";
import { AppContext } from "../../../context/AppContext";
import { useLocation } from "react-router-dom";

const ClientDetails = () => {
  const { t } = useTranslation();
  const { allCases } = useContext(AppContext);

  const taskcardData = allCases?.data?.map((item) => ({
    heading: item.title || "No Title",
    date: item.deadline_date
      ? new Date(item.deadline_date).toLocaleString()
      : "No Deadline",
  }));

  const location = useLocation();
  const clientItem = location.state?.clientItem || null;

  console.log("clientItem in ClientDetails:", clientItem); 

  if (!clientItem) {
    return <p className="text-darkGrey">No case selected</p>;
  }
  const { Option } = Select;

  const months = [
    "January",
    "March",
    "May",
    "July",
    "August",
    "October",
    "November",
  ];
  // const taskcardData = [
  //   {
  //     heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  //   {
  //     heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
  //     date: "October 5, 2024 - 2:00 PM ",
  //   },
  // ];
  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] ">
        <div className="top flex gap-[20px] sm-s:flex-col">

          {/* Client Details  */}
          <div className="cases-div max-w-[25%] max-sm:max-w-[100%] w-full flex flex-col pt-[18px] pb-[21px] px-[25px] gap-[24px] rounded-[20px] bg-[#F4F4F4] shadow-lg">
            <div className="flex justify-between w-100 items-center">
              <h5 className="small font-bold text-blue">
                {t("dashboard.clientInfoManagement.details")}
              </h5>
              <p className="e-small bg-[#DFF2E3] font-medium font-poppins text-[#00B521] rounded-[54px] px-4 py-[6px]">
                {t("dashboard.clientInfoManagement.caseInProgress")}
              </p>
            </div>
            <div className="flex flex-col gap-[15px]">
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.caseID")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.caseID || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.clientName")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.clientName || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.assignedLawyer")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.assignedLawyer || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.opposingCounsel")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.opposingCounsel || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.courtDate")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.courtDate || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.keyContacts")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.keyContacts || "N/A"}
                </p>
              </div>
              <div className="flex items-center justify-between gap-[15px]">
                <p className="text-darkGrey font-semibold medium">
                  {t("dashboard.clientInfoManagement.clientInfo")}:
                </p>
                <p className="text-darkGrey font-semibold medium text-right">
                  {clientItem.description || "N/A"}
                </p>
              </div>
            </div>
          </div>
          
          {/* Upcoming Tasks  */}
          <div class="reminder-div  flex flex-col gap-[25px] max-w-[75%] max-sm:max-w-[100%] max-sm:px-[20px] w-full pt-[23px] px-[33px] rounded-[20px] border-[1.299px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
            <h5 className="small font-bold text-blue">
              {t("dashboard.clientInfoManagement.upcomingTasks")}
            </h5>
            <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[7px] max-sm:pr-[10px] pr-[22px] max-h-[322px] overflow-y-auto">
              {/* <TaskCard taskcardData={taskcardData} /> */}
              <OverviewTable  />
            </div>
          </div>
        </div>
        <UploadedDocs selectedCase={clientItem} />
      </div>
    </>
  );
};

export default ClientDetails;
